export default "__VITE_ASSET__BkLAoPEt__"